import { getVerdictStyle } from "@/lib/verdictStyles";

const HEADLINES = [
  "Fact-checking the feed, one claim at a time",
  "Every verdict backed by authoritative sources",
  "Trained analysts + AI · verified in seconds",
  "Cached checks return instantly to millions",
  "Sign in with Google to unlock unlimited checks",
];

export default function HeadlineTicker() {
  const track = [...HEADLINES, ...HEADLINES];
  return (
    <div
      data-testid="headline-ticker"
      className="border-y border-zinc-900 bg-black text-white overflow-hidden py-2.5"
    >
      <div className="marquee-track">
        {track.map((h, i) => (
          <span
            key={i}
            className="font-mono-plex text-[11px] font-semibold mx-8 flex items-center gap-4"
          >
            <span className="w-1.5 h-1.5 bg-emerald-400 rounded-full" />
            {h}
          </span>
        ))}
      </div>
    </div>
  );
}
